import { DocumentStatus, MISCELLANEOUS } from "../constants/documents";

/**
 * Business Rule: Documents categorized as "Miscellaneous" cannot be approved
 * until they are moved to a specific requirement type.
 */
export function checkIsMiscellaneousApprovalRestricted(
  requirementName: string | undefined,
  status: string | undefined
) {
  return (
    requirementName?.trim().toLowerCase() === MISCELLANEOUS && status === DocumentStatus.APPROVED
  );
}
